import {
  AllAssetListProps,
  AssetTypeChangeList,
  AllAssetData,
  AssetHistoryProps,
  AssetProps,
  ExportAssetListProps,
} from '../../../../types/Assets/AssetList/AssetListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, GetAssetListConfig } from '../../apiList'

const getAssetTypeChangeList = async (
  id: number,
): Promise<AssetTypeChangeList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: GetAssetListConfig.getAssetTypeChange,
    method: AllowedHttpMethods.get,
    params: {
      id,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAllAssetListData = async (
  props: AllAssetListProps,
): Promise<AllAssetData> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: GetAssetListConfig.getAllAssets,
    method: AllowedHttpMethods.post,
    data: props,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const getAssetHistory = async (
  props: AssetProps,
): Promise<AssetHistoryProps[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: GetAssetListConfig.getAssetHistory,
    method: AllowedHttpMethods.get,
    params: {
      assetId: props.assetId,
      searchAssetReference: props.searchAssetReference,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const exportAssetListData = async (
  props: ExportAssetListProps,
): Promise<Blob | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: GetAssetListConfig.exportAssetList,
    method: AllowedHttpMethods.get,
    params: {
      assetss: props.assetss ?? '',
      assetTypeId: props.assetTypeId ?? '',
      productId: props.productId ?? '',
      status: props.status ?? '',
      multiSearch: props.multiSearch ?? '',
      searchByEmpName: props.searchByEmpName ?? '',
      dateSelection: props.dateSelection ?? '',
      fromDate: props.fromDate ?? '',
      toDate: props.toDate ?? '',
      token: localStorage.getItem('token') ?? '',
    },
    responseType: 'blob',
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const AssetLitApi = {
  getAssetTypeChangeList,
  getAllAssetListData,
  getAssetHistory,
  exportAssetListData,
}
export default AssetLitApi
